import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const SFooter = styled.footer`
    position: relative;
    padding: 0px 0px 40px;
    background: #1A1E1F;
    border-top: 2px solid #38393B;
    overflow: hidden;
    margin-top: auto;
`;

export const FooterContainer = styled.div`
    max-width: 62rem;
    padding: 3rem 15px 2rem;
    border-bottom: 2px dashed #3C4043;
    overflow: visible;
    margin: auto;
    position: relative;

    &:before {
        content: " ";
        position: absolute;
        display: block;
        border-left: 2px dashed #3C4043;
        height: 310px;
        top: -100px;
        left: -11%;
        transform: rotate(-45deg);
    }

    &:after {
        content: " ";
        position: absolute;
        display: block;
        border-left: 2px dashed #3C4043;
        height: 310px;
        top: -100px;
        right: -11%;
        transform: rotate(45deg);
    }

    @media (max-width: 800px){
        max-width: fit-content;

        &:before{
            display: none;
        }

        &:after{
            display: none;
        }
    }
`;

//todo {transform-origin}

export const Media = styled.div`
    position: relative;
    margin-bottom: 20px;
    width: fit-content;
    margin: 2rem auto 1rem;
`;

export const MediaList = styled.a`
    display: inline-block;
    margin-right: 20px;
    padding: 0.7rem 0.7rem 0.5rem;
    border: 2px solid #4F4F50;
    border-radius: 50%;
    cursor: pointer;

    &:last-child{
        margin-right: 0rem;
    }

    &:hover{
        opacity: 0.6;
    }
`;

export const Copyright = styled.div`
    font-size: 16px;
    font-weight: bold;
    color: #4F4F50;
    margin-bottom: 10px;
    text-transform: uppercase;
    text-align: center;
`;

export const Row = styled.div`
    display: flex;
`;

export const CRight = styled.div`
    flex: 1;
    font-size: 16px;
    font-weight: 500;
    color: #a8a8a8;
`;

export const TextList = styled(MediaList)`
    margin-left: 30px;
    color: #f0b83d;
    font-weight: bold;
    cursor: pointer;
    margin-right: 0;
`;

export const PreFooter = styled.div`
    width: 100%;
    height: auto;
    position: relative;
    padding: 40px 0;
    background: #131416;
    margin-top: auto;
    overflow: hidden;
`;

export const PreList = styled.ul`
    margin: auto;
    list-style: none;
    width: fit-content;
    display: flex;
    flex-flow: wrap;
    justify-content: center;
`;

export const PreElement = styled(NavLink)`
    margin: 10px;
    color: #565759;
    font-weight: bold;
    font-size: 18px;
    text-transform: uppercase;
    text-decoration: none;

    &:hover{
        opacity: 0.6;
    }
`;

export const FooterTitle = styled.h1`
    margin: 0rem auto 1rem;
    color: #969798;
    font-weight: bold;
    text-transform: uppercase;
    transform: scale(1, 1.2);
    font-size: 1.7em;
    text-align: center;
`;

export const FooterCopyright = styled.h3`
    text-align: center;
    color: #363A3D;
    font-size: 16px;
    font-weight: bold;
    margin: 1rem auto;
`;